import axios from "axios"

import { apiDomain } from "../../store/constants"

const Requirement = {
    getRequirementForms (data) {
        return axios({
            url: apiDomain + `api/requirement-form`,
            method: 'GET',
            params: data
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },

    getRequirementFormById (data) {
        return axios({
            url: apiDomain + `api/requirement-form/${data.id}`,
            method: 'GET',
            params: data
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },

    createRequirementForm (data) {
        return axios({
            url: apiDomain + `api/requirement-form/create`,
            method: 'GET',
            data: data
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },

    saveRequirementForm (data) {
        return axios({
            url: apiDomain + `api/requirement-form`,
            method: 'POST',
            data: data
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },

    editRequirementForm (data) {
        return axios({
            url: apiDomain + `api/requirement-form/${data.id}/edit`,
            method: 'GET',
            data: data
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },

    updateRequirementForm (data) {
        return axios({
            url: apiDomain + `api/requirement-form/${data.id}`,
            method: 'PUT',
            data: data
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },

    deleteRequirementForm (id) {
        return axios({
            url: apiDomain + `api/requirement-form/${id}`,
            method: 'delete',   
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    }
}

export default Requirement